 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~9a7cfb37","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f1a6f51d","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~c810e73c","4":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~8df6e383","8":"source~bet-details-page~betting-history-page","9":"source~i18n-widgets-en-json","10":"source~i18n-widgets-es-json","11":"source~i18n-widgets-pt-json","14":"source~/esports-betting-rules-TR","15":"source~bet-builder-rules-AZ","16":"source~bet-builder-rules-DE","17":"source~bet-builder-rules-EN","18":"source~bet-builder-rules-ES","19":"source~bet-builder-rules-ES-MX","20":"source~bet-builder-rules-ET","21":"source~bet-builder-rules-FI","22":"source~bet-builder-rules-FR","23":"source~bet-builder-rules-IT","24":"source~bet-builder-rules-JA","25":"source~bet-builder-rules-KA","26":"source~bet-builder-rules-LT","27":"source~bet-builder-rules-LV","28":"source~bet-builder-rules-PL","29":"source~bet-builder-rules-PT-BR","30":"source~bet-builder-rules-RO","31":"source~bet-builder-rules-RU","32":"source~bet-builder-rules-SQ","33":"source~bet-builder-rules-SV","34":"source~bet-builder-rules-TR","35":"source~bet-details-page","36":"source~betting-history-container","37":"source~betting-history-page","38":"source~betting-rules-AZ","39":"source~betting-rules-DA","40":"source~betting-rules-DE","41":"source~betting-rules-EN","42":"source~betting-rules-ES","43":"source~betting-rules-ES-MX","44":"source~betting-rules-FR","45":"source~betting-rules-IT","46":"source~betting-rules-JA","47":"source~betting-rules-PL","48":"source~betting-rules-PT","49":"source~betting-rules-PT-BR","50":"source~betting-rules-RO","51":"source~betting-rules-RU","52":"source~betting-rules-SQ","53":"source~betting-rules-SV","54":"source~betting-rules-TR","55":"source~bonus-info","56":"source~cashout-terms-AR","57":"source~cashout-terms-AZ","58":"source~cashout-terms-DA","59":"source~cashout-terms-DE","60":"source~cashout-terms-EN","61":"source~cashout-terms-ES","62":"source~cashout-terms-ES-MX","63":"source~cashout-terms-ET","64":"source~cashout-terms-FI","65":"source~cashout-terms-FR","66":"source~cashout-terms-IT","67":"source~cashout-terms-JA","68":"source~cashout-terms-KA","69":"source~cashout-terms-KU","70":"source~cashout-terms-LT","71":"source~cashout-terms-LV","72":"source~cashout-terms-PL","73":"source~cashout-terms-PT","74":"source~cashout-terms-PT-BR","75":"source~cashout-terms-RO","76":"source~cashout-terms-RU","77":"source~cashout-terms-SQ","78":"source~cashout-terms-SR","79":"source~cashout-terms-SV","80":"source~cashout-terms-TR","81":"source~esports-betting-rules-AZ","82":"source~esports-betting-rules-DA","83":"source~esports-betting-rules-DE","84":"source~esports-betting-rules-EN","85":"source~esports-betting-rules-ES","86":"source~esports-betting-rules-ES-MX","87":"source~esports-betting-rules-ET","88":"source~esports-betting-rules-FI","89":"source~esports-betting-rules-FR","90":"source~esports-betting-rules-IT","91":"source~esports-betting-rules-JA","92":"source~esports-betting-rules-KA","93":"source~esports-betting-rules-LT","94":"source~esports-betting-rules-LV","95":"source~esports-betting-rules-PL","96":"source~esports-betting-rules-PT","97":"source~esports-betting-rules-PT-BR","98":"source~esports-betting-rules-RO","99":"source~esports-betting-rules-RU","100":"source~esports-betting-rules-SQ","101":"source~esports-betting-rules-SR","102":"source~esports-betting-rules-SV","104":"source~generated-mappings","105":"source~i18n-en-json","106":"source~i18n-es-json","107":"source~i18n-pt-json","109":"source~settings-page","110":"source~streaming-carousel","111":"source~virtual-esports-betting-rules-AZ","112":"source~virtual-esports-betting-rules-EN","113":"source~virtual-esports-betting-rules-IT","114":"source~virtual-esports-betting-rules-JA","115":"source~virtual-esports-betting-rules-PL","116":"source~virtual-esports-betting-rules-RU","118":"vendors~rc-slider","119":"vendors~react-google-recaptcha","120":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"e552d0d0735811af038e","1":"59b85aed14e42e4e82b6","2":"1a1cacf0d959cabe8f79","3":"52eb989790f4ab49c428","4":"560bebf481f75cc29cc6","5":"b9c53a45c0a756d457f1","6":"f00a3d4f55deac46fa05","8":"9fbeffb86e5863b6768b","9":"2e144aa1d57b758c8ee3","10":"da8123306bbf33f8ad92","11":"e0a0125b90591735ccec","14":"126c70b2341350e28b83","15":"7ba9d5327a5f71eb9ee4","16":"6b551f2dddad63934f50","17":"2f1581338a130c53a2bc","18":"a6d728bdc61c4424e67f","19":"babe63ff9952c9e53e9e","20":"2d9f530aba4246b80434","21":"618ba9a77f2d6e443fc0","22":"567aa1a6f7b9972abd0d","23":"75e194012573f2d19949","24":"7038d708e1df68481ad7","25":"6d6103b4b05e3d2e7f55","26":"45a6b95f9313f99769ea","27":"e7b56298b04554dc86d2","28":"14959e2b5241cb0a48ad","29":"040381cc77c21be060ac","30":"a004d849b1a608b56760","31":"0dfbde52c49f0e47ce26","32":"a163eac3bcf5295dd99d","33":"e1d7d2cce152a5059321","34":"54ad8365d1d7389cef8f","35":"20920a2d31b0dad51b6e","36":"4bfd7da1ad5c698343be","37":"524d8b1a6bd80d1dc1d1","38":"f64837e26f0cde4d89ab","39":"c01a1791646fddda7ebc","40":"b75c50b3e9bdddca1b2e","41":"1fbdb4732bfb373fa36d","42":"55d9d19fcde40a21e7fb","43":"b86337656141d899162b","44":"d3df199b127c78cf5e79","45":"8ff041070d12456d3a08","46":"575f81b05325d7a2da4d","47":"53ae4db985c9ec817c3e","48":"95262c1490485c0610af","49":"da91dca9a4a09076129b","50":"0f3aae9ef3f9a5ef995a","51":"6888183f40df6031f631","52":"f5b8afb80a0033b7bbd6","53":"b98dc979154116fedc9f","54":"857a210e84bcd56d52cc","55":"7252061089af7ec82c56","56":"56d3df54c2508b902808","57":"3dfa1da24c0dcf2e67d6","58":"1c6a453cbbecb56ba261","59":"09378bc082b72372b478","60":"a516bf162720da6a16f8","61":"3322bc20ff55f7be8328","62":"646ae7f9eeb16e5554cd","63":"193bc386be00c93f390f","64":"c51ecd92d6e83a319cfa","65":"180e7f0ab16576f753fd","66":"d7815b7bce1582b9fbe2","67":"24335477ee8251bf01b5","68":"4b157ee12203dc4ab91d","69":"f70b902bfd405e275dae","70":"b51832bbd029ec6a2a11","71":"ac0bf71e9008f4e00709","72":"5f900ac993858c8491ef","73":"c1e24a0de4b57a503782","74":"fde4409ced21259b6511","75":"ed2aec57e7351ddc90c3","76":"3646e2090d9cbb569499","77":"fc0cd9374a91004d8419","78":"b5878d3b9ef2235ad3c5","79":"d5827c6ddebf6d6caf73","80":"b2a25183557b812cf64b","81":"d74776f531015a47db57","82":"879a58cb287bcd92098a","83":"77ed1862f62a400eacb7","84":"46409c3ba2096540c2d1","85":"0258b49a2466f249c020","86":"732097e13848b8c50081","87":"48a26248f13b32c98dd1","88":"88d4b7b577a1c68d14bf","89":"37c0df55e35e95c8d37e","90":"b570b43739e8e98f721d","91":"c7ab61b48c360c4c523f","92":"2363fb30c14cf60d947c","93":"100b76bf1a0dbb5ebf33","94":"d4a2ca0d086f8d42f60f","95":"97a74056a16ec95b877f","96":"a8c995a4e08660af52f1","97":"cd961eca5c174fdd9d97","98":"b1b5b583b3b4b0eb9da7","99":"de264e8fe9f8c2797780","100":"55679f8529cff0c6b71a","101":"0fe7a9685679349bafdb","102":"c036537ced7561f42438","104":"ac112dba437fe0bc88a9","105":"b78419b62da5b65ae0db","106":"9687cc377653bd1d64a1","107":"e6deead61244205342a9","109":"350b0a18264f518e3409","110":"dcaad371870aea526a1e","111":"a81f5a374a2de631f871","112":"f454a5129c5266c68d69","113":"86d56d3ae8f6859908d6","114":"a90bd58145de28b36f6f","115":"4f7ae6068116a1c0c9b7","116":"ced64824d07d96ccc992","118":"97c87f824a7a9a31a2c8","119":"9a63b325327d7f4e700f","120":"ef79331a72002d83c59c","121":"929e2ffe6fb9ed9acdcf","122":"69a086d13d9adfd024dd","123":"2c73726abbfeca63f763","124":"dd7efb0a4d314a77a322","125":"6136dde6eb6641dd17f9","126":"1cd79aaffc5bfccb3136","127":"d0e69b1f1b3784cf24b0","128":"c5481b9d8e963ba01442","129":"a087b6b290b3767bd7eb","130":"0fbe6a88422ab593c9c7","131":"988e28d2f3d884329d88","132":"43f3decca455f58824c2","133":"f948b90ab671f041f184","134":"d297eac782e031673d17","135":"c4899a206d1a8bff12da","136":"f8e30e3b36bae4bbb63d","137":"a20abc7261bd2766432d","138":"d1e2b8abbd64f774db82","139":"d96267020a5cae29c45d","140":"e2cb0a27a0879903a1a7","141":"9ea7f1e5ffa89f0abfc5","142":"9655042644be43e341ad"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
